if (!customElements.get('rich-text-icons-component')) {
  class RichTextIcons extends HTMLElement {
    constructor() {
      super();
      this.triggers = this.querySelectorAll('.js-logo-trigger');
      this.activeContent = this.querySelector('.rich-text-icons__active-content');
      this.titleEl = this.querySelector('.js-active-title');
      this.linkEl = this.querySelector('.js-active-link');
      this.mobileSlider = this.querySelector('.js-mobile-slider');
      this.mobileSlides = this.querySelectorAll('.rich-text-icons__slide');
      
      this.init();
    }

    init() {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          this.switchContent(trigger);
        });
      });

      // Mobile click to next slide
      if (this.mobileSlider) {
        this.mobileSlides.forEach((slide, index) => {
          const logo = slide.querySelector('.rich-text-icons__slide-logo');
          if (logo) {
            logo.addEventListener('click', () => {
              this.scrollToNext(index);
            });
          }
        });
      }
    }

    scrollToNext(currentIndex) {
      if (!this.mobileSlider) return;
      
      const nextIndex = (currentIndex + 1) % this.mobileSlides.length;
      const nextSlide = this.mobileSlides[nextIndex];
      
      if (nextSlide) {
        this.mobileSlider.scrollTo({
          left: nextSlide.offsetLeft - this.mobileSlider.offsetLeft,
          behavior: 'smooth'
        });
      }
    }

    switchContent(trigger) {
      if (trigger.classList.contains('is-active')) return;

      const title = trigger.dataset.title;
      const url = trigger.dataset.url;

      // Start fade out
      this.activeContent.classList.add('is-transitioning');

      setTimeout(() => {
        // Update content
        if (this.titleEl) this.titleEl.textContent = title;
        if (this.linkEl) {
          if (url) {
            this.linkEl.href = url;
            this.linkEl.classList.remove('hidden');
          } else {
            this.linkEl.classList.add('hidden');
          }
        }

        // Toggle active logo
        this.triggers.forEach(t => t.classList.remove('is-active'));
        trigger.classList.add('is-active');

        // Fade in
        this.activeContent.classList.remove('is-transitioning');
      }, 400); // Matches CSS transition duration
    }
  }

  customElements.define('rich-text-icons-component', RichTextIcons);
}
